export default "__VITE_ASSET__BgO2lNmB__"